import React from 'react';
import { useMsal } from '@azure/msal-react';
import Button from 'lqa-ui/lib/Components/Button';
import LoadingApp from 'lqa-ui/lib/Components/LoadingApp';

/**
 * Renders a sign-out button
 */
export const SignOutButton = () => {
    // const { instance } = useMsal();

    // const handleLogout = (logoutType) => {
    //     if (logoutType === "popup") {
    //         instance.logoutPopup({
    //             postLogoutRedirectUri: "/",
    //             mainWindowRedirectUri: "/"
    //         });
    //     } else if (logoutType === "redirect") {
    //         instance.logoutRedirect({
    //             postLogoutRedirectUri: "/",
    //         });
    //     }
    // }
    return (
        <LoadingApp/>
                // <Button title="Sign out using Redirect" onClick={() => handleLogout("redirect")}/> 
           );
};
